var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSidekickLogo2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 274,
    height: 262,
    viewBox: "0 0 274 262",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.418 49.6777V126.654L72.0289 137.912L57.2088 179.156L42.3405 145.801L0 157.05V80.0735L114.418 49.6777Z",
    fill: "#FFA100"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M216.791 79.7891L231.31 112.586L274 101.172V178.666L159.583 209.267V131.773L202.311 120.343L216.791 79.7891Z",
    fill: "#D09CE7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M246.901 61.7222L225.824 40.6444C202.707 16.459 170.77 1.5 135.494 1.5C100.219 1.5 68.2822 16.459 45.1648 40.6444",
    stroke: "#2574DB",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0879 200.233L45.1648 221.311C68.2822 245.497 100.219 260.456 135.494 260.456C170.77 260.456 202.707 245.497 225.824 221.311",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M67.7473 198.728H22.5825V243.894",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M203.242 63.2275H248.407V18.0609",
    stroke: "#2574DB",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidekickLogo2);
export default __webpack_public_path__ + "static/media/sidekick-logo-2.e59f24219018939506fa4e976fe35296.svg";
export { ForwardRef as ReactComponent };